import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=3057cfeb&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=3057cfeb&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057cfeb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dusanvelickovic/Herd/bookybook/bookybook-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3057cfeb')) {
      api.createRecord('3057cfeb', component.options)
    } else {
      api.reload('3057cfeb', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=3057cfeb&scoped=true", function () {
      api.rerender('3057cfeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/layout/header/Header.vue"
export default component.exports